<section class="payment-form" [ngSwitch]="paymentType">
    <div *ngIf="isAmountShown" class="payment-form__amount-block">
        <label class="form-label form-label--bold">Payment Amount</label>
        <div class="payment-amount">{{ currencyIcon$ | async }}{{ paymentAmount | cmCurrency }}</div>
    </div>
    <cm-stripe-form
        *ngSwitchCase="PAYMENT_TYPES.STRIPE"
        [showError]="showError"
        (formChange)="onPaymentFormChange($event)"
    >
    </cm-stripe-form>
    <cm-payflow-form
        *ngSwitchCase="PAYMENT_TYPES.PAYFLOW_PRO"
        (formChange)="onPaymentFormChange($event)"
        [showError]="showError"
    >
    </cm-payflow-form>
    <cm-square-form
        *ngSwitchCase="PAYMENT_TYPES.SQUARE"
        #squareForm
        [paymentConfig]="publicSettings.squareConfig"
        (nonceChange)="onSquareChange($event)"
    ></cm-square-form>
    <cm-exact-form
        *ngSwitchCase="PAYMENT_TYPES.EXACT"
        [paymentConfig]="publicSettings.exactConfig"
        [paymentAmount]="paymentAmount"
        [step]="step"
        [paymentPlace]="place"
        #exactForm
    ></cm-exact-form>
    <cm-epay-form
        *ngSwitchCase="PAYMENT_TYPES.EPAY"
        #epayForm
        [paymentAmount]="paymentAmount"
        [step]="step"
        [paymentPlace]="place"
    ></cm-epay-form>
    <cm-authorize-net-form
        *ngSwitchCase="PAYMENT_TYPES.AUTHORIZE_NET"
        #authorizeNetForm
        [paymentConfig]="publicSettings.authorizeNetConfig"
        (formChange)="onPaymentFormChange($event)"
        [showError]="showError"
        (displayError)="displayError($event)"
    >
    </cm-authorize-net-form>
</section>

<cm-payment-form-error [errors]="errors"></cm-payment-form-error>
